// extracted by mini-css-extract-plugin
module.exports = {"announcementDetails":"details_announcementDetails__C3XK0","item":"details_item__3v1sa"};